module.exports = __webpack_public_path__ + "static/media/genuine-background-ZH.a72cd856.png";